import { NativeStackHeaderProps, router, Stack } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

const RouteNotFound = () => {
  const { t: translatedText } = useTranslation('routeNotFound');
  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: translatedText('goBackText'),
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      <ErrorScreen
        screenAnalyticsEventKey="Deep Link Error"
        screenType={ErrorScreenType.Error}
        messageHeadline={translatedText('headline')}
        messageBody={translatedText('body')}
        primaryButton={{
          title: translatedText('buttonText'),
          onPress: () => {
            router.replace('/');
          },
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default RouteNotFound;
